/**
 * @file
 * Provide methods for opening and closing the main-menu on mobile devices.
 */

(function ($, Drupal) {
  Drupal.behaviors.menu = {
    attach: function attach(context) {
      let rtime;
      let timeout = false;
      let delta = 200;
      let menu = $('.header__nav');

      function resizeend() {
        if (new Date() - rtime < delta) {
          setTimeout(resizeend, delta);
        } else {
          timeout = false;
          if ($(window).width() >= 768) {
            menu.removeClass('is-open');
            $('#user-menu--dropdown').parent().removeClass('is-open')
          }
        }
      }
      once('awMenuOpen', '.js-menu-open', context).forEach(function(currentElement) {
        currentElement.addEventListener('click', function() {
          menu.addClass('is-open');
        });
      });

      once('awMenuOpen', '.js-menu-close', context).forEach(function(currentElement) {
        currentElement.addEventListener('click', function() {
          menu.removeClass('is-open');
        });
      });


      let window_width_menu = $(window).width();
      $(window).resize(function () {
        let new_window_width = $(window).width();
        if (new_window_width !== window_width_menu) {
          rtime = new Date();
          if (timeout === false) {
            timeout = true;
            setTimeout(resizeend, delta);
          }
          window_width_menu = new_window_width;
        }

      });
    }
  };



  // Close politician menu, when click outside menu detected
  Drupal.behaviors.politicianMenuToggle = {
    attach: function attach(context, settings) {
      once('politician_menu_is_open_menu', '#user-menu--dropdown', context).forEach(function(currentElement) {
        currentElement.addEventListener('click', function(event) {
          $(this).parent().toggleClass('is-open');
          event.preventDefault();
        })
      });

      once('politician_menu_is_open_body', 'body').forEach(function(currentElement) {
        currentElement.addEventListener('click', function(event) {
          if ($(event.target).closest("#user-menu--dropdown").length === 0) {
            $('#user-menu--dropdown').parent().removeClass('is-open');
          }
        })
      });
    }
  };

})(jQuery, Drupal);
